import { tv } from '~/utils/tv'

export const SnackbarTitleVariants = tv({
  base: `
    text-text-neutral text-threeandhalfpulse !font-rdmodern font-bold leading-small
    truncate max-w-full
  `,
})
